import React, { useEffect } from 'react';
import GatewayDetailsComponent from './GatewayDetailsComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';

const GatewayDetailsContainer = (props) => {
    const {
        generalFilterLoadingStatuses,
    } = props.model;

    useEffect(() => {
        return () => {
            props?.actions?.clearGatewayCapabilities();
            props?.actions?.clearAllHeaderStores();
        };
    }, [props?.gatewayID]);

    return <LoadingStatusWrapper
        loadingStatus={[...generalFilterLoadingStatuses]}>
        <GatewayDetailsComponent {...props} />
    </LoadingStatusWrapper >;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const GatewayDetailsContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(GatewayDetailsContainer);

const GatewayDetailsContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(GatewayDetailsContainerWithErrorBoundaryTrigger);

export default React.memo(GatewayDetailsContainerConn);
